import { render, staticRenderFns } from "./SurveyTokenGeneration.vue?vue&type=template&id=27cb884e&scoped=true"
import script from "./SurveyTokenGeneration.vue?vue&type=script&lang=js"
export * from "./SurveyTokenGeneration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cb884e",
  null
  
)

export default component.exports